import { Directive, Inject, Input } from '@angular/core';
import { MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';
import { MaxRangeSelectionStrategy } from '../classes/max-range-selection-strategy';

@Directive({
  selector: '[maxRange]',
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: MaxRangeSelectionStrategy
    }
  ]
})
export class MaxRangeDirective {
  constructor(
    @Inject(MAT_DATE_RANGE_SELECTION_STRATEGY)
    public maxRangeStrategy: MaxRangeSelectionStrategy<unknown>
  ) {}
  @Input() set maxRange(value: string) {
    this.maxRangeStrategy.delta = +Number(value) || 7;
  }
}
